export class JobSpecification {
  author: string;
  title: string;
  product: string | undefined;
  width: string;
  height: string;
  pages: string | undefined;
  quantity1: string;
  quantity2: string;
  quantity3: string;
  initialReprint: string | undefined;
  isbn: string;

  constructor() {
    this.author = "";
    this.title = "";
    this.product = undefined;
    this.width = "";
    this.height = "";
    this.pages = undefined;
    this.quantity1 = "";
    this.quantity2 = "";
    this.quantity3 = "";
    this.initialReprint = undefined;
    this.isbn = "";
  }
}
